import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isAuthenticated = this.authService.isLoggedIn();

    const publicAuthRoutes = ['/auth/login', '/auth/forgot-password', '/auth/reset-password'];
    const isPublicRoute = publicAuthRoutes.some(r => state.url.startsWith(r));

    // Unauthenticated users can always access public auth routes
    if (!isAuthenticated && isPublicRoute) {
      return true;
    }

    // Authenticated users going to login → redirect to dashboard
    if (isAuthenticated && state.url.startsWith('/auth/login')) {
      return this.router.createUrlTree(['/dashboard']);
    }

    // If user is authenticated, allow access to protected routes if they are an admin
    if (isAuthenticated) {
      if (this.authService.hasAdminAccess()) {
        return true;
      }
      
      // If they are authenticated but not an admin, log them out or send to unauthorized page
      this.authService.logout();
      return this.router.createUrlTree(['/auth/login']);
    }

    // If not authenticated, redirect to login
    return this.router.createUrlTree(['/auth/login']);
  }
}
